import { render } from "./ListOfFoods.vue?vue&type=template&id=32d38287&scoped=true"
import script from "./ListOfFoods.vue?vue&type=script&lang=js"
export * from "./ListOfFoods.vue?vue&type=script&lang=js"

import "./ListOfFoods.vue?vue&type=style&index=0&id=32d38287&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32d38287"]])

export default __exports__